import GTextField, { IGTextFieldProps } from "../libs/textfield/GTextField";

export type TOnEval = (text:string) => void;
export interface IEvalTextProps extends IGTextFieldProps {
    onEval:TOnEval
}
export default function EvalText(props:IEvalTextProps){
    const {onEval, ...textProps} = props;
    const _onEval = (e:any) => {
        try {
            const p = parseFloat(eval(e.target.value))
            if (!isNaN(p)) onEval(p.toString())
            else onEval("")
        }catch(e){
            console.log(e)
        }
    }
    return <GTextField {...textProps} floatLabel={props.placeholder} onBlur={_onEval} autoComplete="off" autoCorrect="false"/>
}